import React from 'react';

function InvoiceLayout({ header, children, footer }) {
    return (
        <table className="w-full rounded-[20px] shadow-[0px_0px_60px_0px_rgba(79,98,130,0.10)] print:shadow-none">
            <thead>
                <tr>
                    <th className="text-left">
                        {header} <hr className="border-t border-[rgb(237,115,128)]" />
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td>{children}</td>
                </tr>
            </tbody>

            <tfoot className="hidden print:table-footer-group break-inside-avoid">
                <tr>
                    <td className="h-[200px]">{footer}</td>
                </tr>
            </tfoot>
        </table>
    );
}

export default InvoiceLayout;
